module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/_common/page-not-found/page-not-found.component.css
// module id = ./src/app/sharedcomponents/_common/page-not-found/page-not-found.component.css
// module chunks = main